import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import { Button, Card, Col, Row, Space, Spin } from 'antd';
import { LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';

import PlannerNoteList from '../containers/PlannerNotesListContainer';
import PlannerNoteCSVButton from '../containers/PlannerNotesCSVButtonContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import { pathTo } from '../../../Routes';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';

class PlannerNoteScreen extends Component {
  static defaultProps = {
    limit: Config.get('DEFAULT_LIST_LENGTH', 10),
    isLoading: true,
  };

  scrollToTop = () => {
    Logger.log('debug', `PlannerNoteScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    const loadingIcon = (
      <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
    );
    const page = parseInt(
      this.props.match.params.page ? this.props.match.params.page : 1
    );
    const { order, ...filter } = QueryString.parse(this.props.location.search);

    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('planner_note_route_list')} />

            <Row>
              <Col span={24}>
                <Card
                  title={
                    <Space size={10}>
                      {t('planner_note_list_title')}
                      <Button
                        size="small"
                        icon={<PlusCircleOutlined />}
                        onClick={(e) =>
                          this.props.history.push(
                            pathTo('PlannerNoteAddScreen')
                          )
                        }
                      >
                        {t('action_create')}
                      </Button>
                      <PlannerNoteCSVButton order={order} filter={filter} />
                    </Space>
                  }
                  extra={this.props.isLoading ? loadingIcon : null}
                >
                  <PlannerNoteList
                    key={page}
                    component="PlannerNotesScreen"
                    page={page}
                    limit={this.props.limit}
                    order={order || 'updated_at.desc'}
                    filter={filter}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerNoteScreen;

Logger.log('silly', `PlannerNoteScreen loaded.`);
